__webpack_require__.p = "/reports-chart-single-dataset/onboarding/";